<div class="nacha-confirm-create-ach-token-modal">
  <div class="confirm-header">
    <mat-icon>account_balance</mat-icon>
    <p>Create an ACH token for <strong>{{ customerName }}</strong> using the bank account information from the NACHA file?</p>
  </div>

  @if (row) {
    <div class="token-preview">
      <div class="token-preview-row">
        <span class="label">Routing Number</span>
        <span class="value">{{ row.routingNumber }}</span>
      </div>
      <div class="token-preview-row">
        <span class="label">Bank Account</span>
        <span class="value">{{ maskAccount(row.bankAccountNumber) }}</span>
      </div>
      <div class="token-preview-row">
        <span class="label">Account Holder</span>
        <span class="value">{{ row.individualName }}</span>
      </div>
      <div class="token-preview-row">
        <span class="label">Account Type</span>
        <span class="value">{{ row.accountType }}</span>
      </div>
      <div class="token-preview-row">
        <span class="label">Transaction Type</span>
        <span class="value">{{ row.transactionTypeLabel }}</span>
      </div>
    </div>
  }

  <p class="confirm-note">
    <mat-icon>info</mat-icon>
    This token will be saved to the customer's account for future use.
  </p>
</div>
